
import { Col, Row } from 'reactstrap';
import ValidationField from '../../../Components/ValidationField/ValidationField';

function Form() {

  return (
    <Row xs={1} sm={1} md={1} lg={2} xl={2}>
      <Col>
      <ValidationField name="new_password" />


      </Col>
      <Col>
    
      <ValidationField name="old_password" />

      </Col>



    </Row>
  )
}

export default Form




